import { useMutation } from "@tanstack/react-query";

import { queryClient } from "utils";

import { saveFilters } from ".";

/** Persist the full committed filter store (incl. per-group tag keys). */
export function useSaveFilters(slug: string | undefined) {
  return useMutation({
    mutationKey: ["saveFilters", slug],
    mutationFn: async (filter: Record<string, unknown>) => {
      if (!slug) throw new Error("Missing property slug");
      const visitor_uuid = queryClient.getQueryData<string>(["visitorUUID"]);
      if (!visitor_uuid) throw new Error("Missing visitor UUID");
      return saveFilters(slug, { visitor_uuid, filter: { ...filter } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bootstrap"] });
    },
    onError: (error) => {
      console.error("[save_filters] error:", error);
    },
  });
}
